import React from 'react';
import { Col, Row, Text } from 'components';
import { StyleSheet } from 'react-native';

interface IssuesCountCardProps {
  issuesByType: {
    [key: string]: number;
  };
}

const IssuesCountCard: React.FC<IssuesCountCardProps> = ({ issuesByType }) => {

  const displayTypes = {
    'missing': {
      label: 'Missing',
      color: '#E94A36',
    },
    'damaged': {
      label: 'Damaged',
      color: '#F5A623',
    },
    'wrong-item': {
      label: 'Wrong Item',
      color: '#004B8D',
    },
    'other': {
      label: 'Other',
      color: '#1FA463',
    },
  }
  return (
    <Col style={styles.IssuesCountCard} flex1>
      <Text fontSize={18} semiBold color="#4B5563" style={{ letterSpacing: 0.5 }}>
        ISSUES BY TYPE
      </Text>
      {Object.entries(issuesByType).map(([type, count]) => (
        <Row key={type} alignItems="center" marginTop={8} justifyContent="space-between">
          <Text fontSize={14}>{displayTypes[type].label}</Text>
          <Text fontSize={16} fontWeight="bold" color={displayTypes[type].color}>{count}</Text>
        </Row>
      ))}
    </Col>
  );
};

const styles = StyleSheet.create({
  IssuesCountCard: {
    backgroundColor: 'white',
    padding: 24,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: '#E2E8F0',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 4,
    elevation: 1,
  },
  progressBar: {
    width: '100%',
    height: 8,
    backgroundColor: '#E5E7EB',
    borderRadius: 4,
    overflow: 'hidden',
  },
  progressFill: {
    height: '100%',
    borderRadius: 4,
  },
});

export default IssuesCountCard;

